// extracted by mini-css-extract-plugin
export default {"button":"LegacyButton_button__bV3hh","disabled":"LegacyButton_disabled__BSVFM","primary":"LegacyButton_primary__1dUgA","secondary":"LegacyButton_secondary__GSko1"};